import { render, staticRenderFns } from "./PurchasePlanAdd.vue?vue&type=template&id=cb7c2954&"
import script from "./PurchasePlanAdd.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports